<template>
    <main-section class="main-section--sm main-gallery">
        <v-row align="center">
            <v-col>
                <tit-primary>갤러리</tit-primary>
            </v-col>
            <v-col cols="auto">
                <router-link to="/edu-gallery" class="main-gallery__more-btn">
                    <txt-primary class="txt--sm">MORE<span class="plus">+</span></txt-primary>
                </router-link>
            </v-col>
        </v-row>

        <div class="board-list">
            <v-row no-gutters>
                <v-col v-for="(gallery, index) in galleries" :key="index" cols="6" md="4" lg="3">
                    <dialog-secondary>
                        <template #activator="{ attrs, on }">
                            <div v-bind="attrs" v-on="on" class="board-list__item">
                                <v-img :src="gallery.image" :aspect-ratio="282 / 211" cover :alt="gallery.subject" />
                            </div>
                        </template>

                        <v-img :src="gallery.image" :alt="gallery.subject" />
                    </dialog-secondary>
                </v-col>
            </v-row>
        </div>
    </main-section>
</template>

<script>
import api from "@/api";

import MainSection from "@/sets/styles/mains/main-section.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";
import TitPrimary from "@/components/publish/parents/typography/tit-primary.vue";
import DialogSecondary from "@/components/publish/parents/dialogs/dialog-secondary.vue";
export default {
    components: {
        MainSection,
        TxtPrimary,
        TitPrimary,
        DialogSecondary,
    },
    data() {
        return {
            galleries: [],
        };
    },
    mounted() {
        this.search();
    },
    methods: {
        async search() {
            try {
                let { galleries } = await api.v1.gallery.gets({
                    params: { isMain: true },
                });
                this.galleries = galleries;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.main-gallery {
    &__more-btn {
        display: flex;
        align-items: center;
        position: relative;
        min-height: 30px;
        @media (min-width: 768px) {
            min-height: 40px;
        }
        .txt {
            display: block;
            height: fit-content;
            font-weight: 600;
            color: var(--v-primary-base);
            padding-left: 1px;
            .plus {
                font-size: 1.2em;
                margin-left: 8px;
                @media (min-width: 768px) {
                    margin-left: 12px;
                }
            }
        }
        &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 2px;
            transition: width 0.2s ease-in-out;
            background-color: var(--v-primary-base);
        }
        &:hover {
            &::after {
                width: 100%;
            }
        }
    }
}
.board-list {
    padding-top: 20px;
    @media (min-width: 768px) {
        padding-top: 40px;
    }
    > .row {
        margin: -12px -8px !important;
        @media (min-width: 768px) {
            margin: -20px -12px !important;
        }
        > [class*="col"] {
            padding: 12px 8px !important;
            @media (min-width: 768px) {
                padding: 20px 12px !important;
            }
        }
    }
    &__item {
        position: relative;
        &::before,
        &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
        }
        &::before {
            width: 100%;
            height: 0;
            background: rgba(0, 0, 0, 0.4);
            z-index: 1;
            transition: height 0.2s ease-in-out;
        }
        &::after {
            width: 0;
            height: 4px;
            background-color: var(--v-primary-base);
            z-index: 2;
            transition: width 0.2s ease-in-out;
        }
        &:hover {
            &::before {
                height: 100%;
            }
            &::after {
                width: 100%;
            }
        }
    }
}
</style>
